import { createContext } from "react";

const ItemContext = createContext({});

export default ItemContext;